"use client";

import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "fumadocs-ui/components/ui/popover";
import type { ThemeSwitchProps } from "fumadocs-ui/layouts/shared/slots/theme-switch";
import { useTheme } from "fumadocs-ui/provider/base";
import { Check, Monitor, Moon, Sun } from "lucide-react";

const themes = [
  { value: "system", label: "System", icon: Monitor },
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
] as const;

export function ThemeSelect({ className }: ThemeSwitchProps) {
  const { setTheme, theme = "system" } = useTheme();
  const SelectedIcon =
    themes.find(({ value }) => value === theme)?.icon ?? Monitor;

  return (
    <Popover>
      <PopoverTrigger
        aria-label="Select theme"
        className={`flex size-9 items-center justify-center rounded-full bg-fd-secondary text-fd-muted-foreground transition-colors hover:text-fd-foreground ${className ?? ""}`}
      >
        <SelectedIcon className="size-4" aria-hidden="true" />
      </PopoverTrigger>
      <PopoverContent align="end" className="min-w-36 p-1.5">
        {themes.map(({ value, label, icon: Icon }) => (
          <PopoverClose asChild key={value}>
            <button
              type="button"
              onClick={() => setTheme(value)}
              className="flex w-full items-center gap-2 rounded-lg px-2.5 py-2 text-left text-sm hover:bg-fd-accent"
            >
              <Icon className="size-4" aria-hidden="true" />
              <span className="flex-1">{label}</span>
              {theme === value ? (
                <Check className="size-4" aria-hidden="true" />
              ) : null}
            </button>
          </PopoverClose>
        ))}
      </PopoverContent>
    </Popover>
  );
}
